import {Component} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {AgentsService} from "OpsCenter/agents/agents.service";

@Component({
  selector: 'app-agents',
  template: require('./agents.component.html'),
  styles: [require('./agents.component.less')],
})
export class AgentsComponent {
  public agentName = null;
  public agents = [];

  constructor(private agentsService: AgentsService, private notificationService: ToastrService) {
    this.getAgents();
  }

  getAgents() {
    this.agentsService.getAgents().subscribe(data => {
      if (data) {
        this.agents = data.agents;
      }
    });
  }

  createAgent() {
    this.agentsService
      .createAgent(this.agentName)
      .subscribe(this.handleUpdateSuccess(), this.handleUpdateFailure());
  }

  private handleUpdateSuccess() {
    return () => {
      this.notificationService.success('Agent created');
      this.getAgents();
    };
  }t

  private handleUpdateFailure() {
    return () => {
      this.notificationService.error('Failed to create agent')
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/agents/agents.component.ts